import { ITrainingActivityType } from '../../types/interfaces/training-activity-type';

export function getTrainingActivityTypeName(
  training:
    | {
        activityTypeId?: string | null;
        activityType?: { name?: string } | null;
      }
    | null
    | undefined,
  activityTypes: ITrainingActivityType[] = [],
): string | null {
  if (training?.activityType?.name) {
    return training.activityType.name;
  }

  if (!training?.activityTypeId) {
    return null;
  }

  return (
    activityTypes.find((type) => type.id === training.activityTypeId)?.name ??
    null
  );
}
